/**
 * @desc 更新模板
 */
import { TemplateEntity } from '@eastcoal/api/contract/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateTemplateParameter = TemplateEntity

const method = 'PUT'
const url = '/contract/template'

export const updateTemplateApi = (
  data?: UpdateTemplateParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<TemplateEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateTemplateApi.method = method
updateTemplateApi.url = url
